import type { StudentListElementVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveStudents = createApiThunk<StudentListElementVM[], void>(
  "students/retrieveStudents",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listStudents();
  },
);
